import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

const AddToSlackModal = ({ open, setOpen , channel_id }) => {
  const redirectUri = encodeURIComponent("https://app.twilanswer.com/dashboard/channels");
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Add to Slack</div>


        <div className="lg:text-[14px] text-[13px] text-center">
        Click the button below to install our slack app
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "black",
                    fontWeight: 'bold',
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1.5px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    window.open('https://slack.com/oauth/v2/authorize?scope=incoming-webhook&client_id=8216119482166.8222742235810&redirect_uri='+redirectUri+'&state=channel_id:'+channel_id, '_blank');
                  }}
                >
              <img src='/icons/slack.png' className="w-[24px] mr-2" />    Add to Slack
                </Button>
                
        </div>



        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1.5px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    setOpen(false)
                  }}
                >
                  Close
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default AddToSlackModal;
